import { Link } from 'react-router-dom';

const footerLinks = {
  service: {
    title: '服务支持',
    items: [
      { label: '会员权益', path: '/category/membership' },
      { label: '正品保障', path: '/about' },
      { label: '常见问题', path: '/#faq' },
      { label: '联系客服', path: '/about#contact' },
    ],
  },
  company: {
    title: '关于我们',
    items: [
      { label: '品牌介绍', path: '/about' },
      { label: '信誉展示', path: '/about#reputation' },
      { label: '联系方式', path: '/about#contact' },
      { label: '加入我们', path: '/about' },
    ],
  },
  resource: {
    title: '平台资源',
    items: [
      { label: '平台资讯', path: '/category/news' },
      { label: '使用指南', path: '/category/guide' },
      { label: '最新动态', path: '/category/news' },
      { label: '会员专区', path: '/category/membership' },
    ],
  },
};

export default function Footer() {
  return (
    <footer className="bg-background-900 text-background-200">
      <div className="w-full px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
            <Link
              to="/"
              className="text-2xl font-heading font-bold text-background-50 hover:text-primary-400 transition-colors cursor-pointer"
            >
              hth
            </Link>
            <p className="mt-4 text-sm text-background-400 leading-relaxed">
              hth官方平台致力于为用户提供正品保障、极速响应与全方位服务支持，是您值得信赖的首选平台。
            </p>
          </div>

          {Object.values(footerLinks).map((section) => (
            <div key={section.title}>
              <h4 className="text-sm font-semibold text-background-50 mb-4">
                {section.title}
              </h4>
              <ul className="flex flex-col gap-2.5">
                {section.items.map((item) => (
                  <li key={item.label}>
                    <Link
                      to={item.path}
                      className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer"
                    >
                      {item.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-12 pt-8 border-t border-background-700/50 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-background-500">
            &copy; {new Date().getFullYear()} hth官方平台 版权所有
          </p>
          <div className="flex items-center gap-6">
            <a href="/" className="text-xs text-background-500 hover:text-primary-400 transition-colors cursor-pointer">
              隐私政策
            </a>
            <a href="/" className="text-xs text-background-500 hover:text-primary-400 transition-colors cursor-pointer">
              服务条款
            </a>
            <a href="/" className="text-xs text-background-500 hover:text-primary-400 transition-colors cursor-pointer">
              Cookie 设置
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}